import { Navbar } from 'reactstrap';
import styled from 'styled-components';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import MyFirm from '#/components/Leaderboard/MyFirm';
import Tabs from '#/components/Leaderboard/LeaderboardTabs';
import GoPublicSwitch from '#/components/Leaderboard/GoPublicSwitch';

export default function LeaderboardHeader() {
  const isMobile = useIsMobile();

  return (
    <Header>
      <HeaderSection>
        {!isMobile && <HeaderTitle>Leaderboard</HeaderTitle>}
        <Tabs />
      </HeaderSection>
      <SettingsSection>
        {!isMobile && <GoPublicSwitch />}
        {!isMobile && <MyFirm />}
      </SettingsSection>
    </Header>
  );
}

const HeaderTitle = styled.span`
  padding-bottom: 5px;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
`;

const Header = styled(Navbar)`
  padding: 19px 30px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0;
    margin-bottom: -3px;
    display: flex;
    justify-content: center;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  &:first-child {
    gap: 3rem;
  }
`;

const SettingsSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
